import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import * as UserRewardActions from "./user.rewards.actions";
import { Reward } from "../../modals/user.reward";

export interface UserRewardState extends EntityState<Reward> {
    hasNextPage?: boolean,
    isLoaded?: boolean,
    errorMessage?: string;
    isLoading?: boolean;
}

export const rewardAdapter: EntityAdapter<Reward> = createEntityAdapter<Reward>(
    { selectId: (reward: Reward) => reward.identifier }
);

const initialActivityState = rewardAdapter.getInitialState({
    isLoading: true
});

const _userRewardReducer = createReducer(
    initialActivityState,
    on(UserRewardActions.userRewardRequested, (state) => {
        return { ...state, isLoaded: false, isLoading: true };
    }),
    on(UserRewardActions.userRewardLoaded, (state, { userReward, hasNextPage, isLoaded }) => {
        return rewardAdapter.addMany(userReward, {
            ...state, hasNextPage,
            isLoaded, isLoading: false
        });
    }),
    on(UserRewardActions.userRewardResetCompleted, (state, { userReward, hasNextPage }) => {
        return rewardAdapter.setAll(userReward, { ...state, hasNextPage, isLoaded: true });
    }),
    on(UserRewardActions.userRewardLoadingError, (state, { errorMessage }) => {
        return { ...state, hasNextPage: true, isLoaded: false, errorMessage, isLoading: false }
    })
);

export function userRewardReducer(state: UserRewardState | undefined, action: any): UserRewardState {
    return _userRewardReducer(state, action);
}

const loadingInitialState = false;
const _rewardLoadingReducer = createReducer(
    loadingInitialState,
    on(UserRewardActions.userRewardLoading, (state, { isLoading }) => isLoading)
);

export function rewardLoadingReducer(state: boolean | undefined, action: any): boolean {
    return _rewardLoadingReducer(state, action);
}

const isRewardAllowedInitialState = false;
const _isRewardAllowedReducer = createReducer(
    isRewardAllowedInitialState,
    on(UserRewardActions.rewardAllowedRequested, () => false),
    on(UserRewardActions.rewardAllowedLoaded, () => true)
);

export function isRewardAllowedReducer(state: boolean | undefined, action: any): boolean {
    return _isRewardAllowedReducer(state, action);
}

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = rewardAdapter.getSelectors();